import { Grid } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MobileStores } from "../../components/common/MobileStores";
import { useAppDispatch } from "../../hooks/redux";
import { RoutesNames } from "../../routes/enum";
import { authSlice } from "../../store/reducers/AuthSlice";
import { FirstStep } from "../../components/reset/FirstStep";
import { SecondStep } from "../../components/reset/SecondStep";
import { ThirdStep } from "../../components/reset/ThirdStep";
import { useTranslation } from "react-i18next";
import { MobileAlert } from "../../components/common";

export const ResetPasswordPage = () => {
    const [step, setStep] = useState<number>(1);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { sm } = Grid.useBreakpoint();

    useEffect(() => {
        return () => {
            dispatch(authSlice.actions.setErrorMessage(""));
        };
    }, []);

    const handleChangeStep = () => {
        step !== 3 && setStep((prev) => prev + 1);
    };

    const formItem = () => {
        switch (step) {
            case 1:
                return <FirstStep handleChangeStep={handleChangeStep} />;
            case 2:
                return <SecondStep handleChangeStep={handleChangeStep} />;
            case 3:
                return <ThirdStep />;
            default:
                return <FirstStep handleChangeStep={handleChangeStep} />;
        }
    };

    return (
        <div className="wrapper">
            {!sm && <MobileAlert />}
            <div className="form">
                <img width={140} src="/images/VMS_logo.png" alt="logo" />
                <h1>{t("Forgot password?")}</h1>
                <span className="steps">{t("Three steps", { step })}</span>
                {formItem()}
                <div className="sign-up_link">
                    {t("Already registered?")} <Link to={RoutesNames.LOGIN}>{t("Log in")}</Link>
                </div>
            </div>
            {sm && <MobileStores />}
        </div>
    );
};
